// extracted by mini-css-extract-plugin
export var title1 = "typography-module--title1--wIjAN";
export var title2 = "typography-module--title2--bsCgN";
export var title3 = "typography-module--title3--T9iqb";
export var large = "typography-module--large--M3VUX";
export var base = "typography-module--base--9SlXw";
export var small = "typography-module--small--Jy8K4";
export var micro = "typography-module--micro--PpQ+8";
export var paragraph = "typography-module--paragraph--vZam7";
export var blockQuote = "typography-module--blockQuote--Kp7gi";
export var responsiveTitle1 = "typography-module--responsiveTitle1--kn8kK";
export var responsiveTitle2 = "typography-module--responsiveTitle2--hNMps";
export var responsiveTitle3 = "typography-module--responsiveTitle3--Pv8yt";
export var responsiveTitle4 = "typography-module--responsiveTitle4--szdqw";